import type {
  DtoApplication,
  DtoApplicationBorrower,
} from "@porchpass/api-client";
import type { BorrowerInviteHandlerParams } from "src/types/dashboard";
import type { SetUserDataProps } from "../../types";

export const setInvitedCoBorrowerUserData = (
  application: DtoApplication,
  authBorrower: DtoApplicationBorrower,
  mainBorrower: string | undefined,
  setUserData?: SetUserDataProps,
) => {
  const { status, is_primary, id: auth_borrower_id } = authBorrower;

  // Explicitly not passing the application_id or this will bug out the registration page.
  setUserData?.((prev) => ({
    ...prev,
    status,
    is_primary,
    application_id: undefined,
    borrower_id: undefined,
    auth_user_borrower_id: authBorrower.id,
    dealer_id: application.dealer?.id,
    roles: {
      borrower: mainBorrower,
      coborrowers: auth_borrower_id ? [auth_borrower_id] : [],
    },
  }));
};

export const handleCoborrowerInviteRoute = (
  application: DtoApplication,
  authBorrower: DtoApplicationBorrower,
  mainBorrower: string | undefined,
  { setUserData, navigate, dealerName }: BorrowerInviteHandlerParams,
  isReturningUser = false,
) => {
  const { id: application_id } = application;
  const { id: auth_borrower_id } = authBorrower;

  setInvitedCoBorrowerUserData(
    application,
    authBorrower,
    mainBorrower,
    setUserData,
  );
  console.log(`Redirecting to coborrower registration for ${application_id}`);
  const route = `/${dealerName}/register/${application_id}/coborrower/${auth_borrower_id}`;
  navigate(`${route}${isReturningUser ? "?isReturningUser=true" : ""}`);
};
